import bootcamps from '~helpers/analytics/bootcamps.json'
import contact from '~helpers/analytics/contact.json'
import demo from '~helpers/analytics/demo.json'
import featureFlags from '~helpers/analytics/feature-flags.json'
import global from '~helpers/analytics/global.json'
import product from '~helpers/analytics/product.json'
import reliabilityCalculator from '~helpers/analytics/reliability-calculator.json'
import whitepapers from '~helpers/analytics/whitepapers.json'
import recaps from '~helpers/analytics/recaps.json'
import roi from '~helpers/analytics/roi.json'
import scroll from '~helpers/analytics/scroll.json'

const analyticsSchema = {
  ...bootcamps,
  ...contact,
  ...demo,
  ...featureFlags,
  ...global,
  ...product,
  ...reliabilityCalculator,
  ...whitepapers,
  ...recaps,
  ...roi,
  ...scroll,
}

/**
 *
 * @param {String} identifier Should match what is within the `analyticsSchema`
 * @param  {...any} rest Any dynamic custom properties to be passed-along
 */
export default function track(identifier, ...rest) {
  // Grabs all available static-fields we'll use to pass-along with the event
  const trackProperties = Object.entries(
    analyticsSchema[identifier] || {}
  ).reduce((accumulator, [key, value]) => {
    // If any keys match the pattern below -> don't include them
    if (!['_meta'].includes(key)) {
      accumulator[key] = value
    }

    // For any events that have their trigger set to `load`, pass in GA-specific utility
    if (key === 'trigger' && value === 'load') {
      accumulator.non_interaction = true
    }

    return accumulator
  }, {})

  if (window.analytics) {
    window.analytics.track(identifier, {
      ...trackProperties,
      ...rest[0],
    })
  } else {
    // eslint-disable-next-line no-console
    console.table({
      name: identifier,
      ...trackProperties,
      ...rest[0],
    })
  }
}
